import React from 'react';
import { useQuery } from '@tanstack/react-query';
import Layout from '../components/Layout';
import { listChurches } from '../api/hubDirectoryService';

const ChurchDirectoryPage: React.FC = () => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['church-directory-list'],
    queryFn: listChurches,
  });

  const rows = data?.data || [];

  return (
    <Layout>
      <div className="px-4 sm:px-0">
        <h1 className="text-2xl font-bold text-gray-900">Church directory</h1>
        <p className="mt-1 text-sm text-gray-600">Churches in the network.</p>

        {isLoading && <p className="mt-6 text-sm text-gray-600">Loading…</p>}
        {isError && (
          <div className="mt-6 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800">
            Failed to load churches.{' '}
            <button type="button" className="font-medium underline" onClick={() => refetch()}>
              Retry
            </button>
          </div>
        )}
        {!isLoading && !isError && (
          <ul className="mt-6 divide-y divide-gray-200 rounded-lg border border-gray-200 bg-white shadow">
            {rows.length === 0 ? (
              <li className="px-4 py-8 text-center text-sm text-gray-500">No churches found.</li>
            ) : (
              rows.map((ch) => (
                <li key={ch.id} className="px-4 py-3">
                  <div className="font-medium text-gray-900">{ch.churchName}</div>
                  <div className="text-sm text-gray-600">
                    {[ch.city, ch.state].filter(Boolean).join(', ') || '—'}
                    {ch.denomination ? ` · ${ch.denomination}` : ''}
                  </div>
                  {ch.contactName ? (
                    <div className="text-xs text-gray-500 mt-0.5">{ch.contactName}</div>
                  ) : null}
                </li>
              ))
            )}
          </ul>
        )}
      </div>
    </Layout>
  );
};

export default ChurchDirectoryPage;
